import classNames from 'classnames'

import type { ReactElement } from 'react'

import defaultAvatarPicture from '~/assets/default-avatar.png'
import Image from '~/components/Image'

import './styles.scss'

export interface Props {
  className?: string
  pictureUrl?: string
  size?: Exclude<SIZES, 'large'>
}

const Avatar = ({ className, pictureUrl, size = 'medium' }: Props): ReactElement => {
  return (
    <div className={classNames('avatar-component', className, size)}>
      <Image alt="avatar" className="avatar-img" src={pictureUrl || defaultAvatarPicture} />
    </div>
  )
}

export default Avatar
